import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

export interface DiscardChangesConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirmDiscard: () => void;
}

export const DiscardChangesConfirmDialog: React.FC<DiscardChangesConfirmDialogProps> = React.memo(({
  open,
  onClose,
  onConfirmDiscard,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, pt: 2, px: 2.5, fontWeight: 700, fontSize: '1.05rem', color: 'text.primary' }}>
        Unsaved Changes
      </DialogTitle>

      <DialogContent sx={{ px: 2.5, py: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem', lineHeight: 1.5 }}>
          You have unsaved changes. Discarding will revert all edits.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 2.5, pb: 2, pt: 1.5, gap: 1 }}>
        <Button onClick={onClose} color="inherit" sx={{ textTransform: 'none', fontWeight: 600 }}>
          Cancel
        </Button>
        <Button
          onClick={onConfirmDiscard}
          color="error"
          variant="contained"
          autoFocus
          sx={{ textTransform: 'none', fontWeight: 600, px: 2.5, borderRadius: '8px', boxShadow: 'none' }}
        >
          Discard Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
});

DiscardChangesConfirmDialog.displayName = 'DiscardChangesConfirmDialog';
